function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#81A2B2",
  d: "M18 .855A17.145 17.145 0 11.855 18 17.163 17.163 0 0118 .855zM18 0a18 18 0 100 36 18 18 0 000-36z",
  opacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A99D",
  d: "M10.499 22.261l1.989 3.114a.855.855 0 001.449 0l4.441-7.231-3.303-5.391-4.603 7.708a1.705 1.705 0 00.027 1.8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EF445A",
  d: "M26.289 20.461l-4.604-7.708-3.307 5.4 4.446 7.231a.855.855 0 001.449 0l1.989-3.114a1.72 1.72 0 00.027-1.809z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#01445A",
  d: "M20.421 10.633L19.107 8.55a.855.855 0 00-1.453 0l-1.314 2.088-1.265 2.115 3.303 5.4 3.308-5.377-1.265-2.143z"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4IDM2YzkuOTQxIDAgMTgtOC4wNTkgMTgtMThTMjcuOTQxIDAgMTggMCAwIDguMDU5IDAgMThzOC4wNTkgMTggMTggMTh6Ii8+CiAgPHBhdGggZmlsbD0iIzgxQTJCMiIgZD0iTTE4IC44NTVBMTcuMTQ1IDE3LjE0NSAwIDExLjg1NSAxOCAxNy4xNjMgMTcuMTYzIDAgMDExOCAuODU1ek0xOCAwYTE4IDE4IDAgMTAwIDM2IDE4IDE4IDAgMDAwLTM2eiIgb3BhY2l0eT0iLjI1Ii8+CiAgPHBhdGggZmlsbD0iIzAwQTk5RCIgZD0iTTEwLjQ5OSAyMi4yNjFsMS45ODkgMy4xMTRhLjg1NS44NTUgMCAwMDEuNDQ5IDBsNC40NDEtNy4yMzEtMy4zMDMtNS4zOTEtNC42MDMgNy43MDhhMS43MDUgMS43MDUgMCAwMC4wMjcgMS44eiIvPgogIDxwYXRoIGZpbGw9IiNFRjQ0NUEiIGQ9Ik0yNi4yODkgMjAuNDYxbC00LjYwNC03LjcwOC0zLjMwNyA1LjQgNC40NDYgNy4yMzFhLjg1NS44NTUgMCAwMDEuNDQ5IDBsMS45ODktMy4xMTRhMS43MiAxLjcyIDAgMDAuMDI3LTEuODA5eiIvPgogIDxwYXRoIGZpbGw9IiMwMTQ0NUEiIGQ9Ik0yMC40MjEgMTAuNjMzTDE5LjEwNyA4LjU1YS44NTUuODU1IDAgMDAtMS40NTMgMGwtMS4zMTQgMi4wODgtMS4yNjUgMi4xMTUgMy4zMDMgNS40IDMuMzA4LTUuMzc3LTEuMjY1LTIuMTQzeiIvPgo8L3N2Zz4K";
export { SvgLogo as ReactComponent };